import React, { useState, useContext, useEffect } from 'react';
import { Redirect } from 'react-router';
import { AppDataContext } from "../AppDataContext"
import useNetwork from '../../useNetwork';
import { Loader } from '../Loader';
import { Helmet } from "react-helmet";

export function Logout(props) {

    const context = useContext(AppDataContext); 
    const { loading, networkError, netRequest, netRenderError } = useNetwork(false);

    // error message at the top
    const [message, setMessage] = useState(null);
    const [isError, setIsError] = useState(false);
    const [isDeactivated, setIsDeactivated]= useState(false);


    const logout = async (all) => {
        setIsError(false);
        setMessage(null);

        const url = 'api/site/logout';
        const postData = {
            Param: all,
        };
        const resp = await netRequest(url, postData);

        if (resp.isError) {
            setMessage("An error occurred. Please try again.  If this continues, close and reopen your browser. (code: " + resp.status + ")");
        } else {
            context.loggedOut();
        }      
    }
    const logoutSite = async () => {
        logout('');
    }
    const logoutAllDevices = async () => {
        logout('all');
    }
        
    return (
        <>
            <Helmet>
                <title>Logout</title>
            </Helmet>
            <div class="row mt-3">
                <div class="col-12 mb-1">
                    <h4 class="auction-grid-header">
                        Logout
                        <div class="divider mt-2"></div>
                    </h4>
                    {
                        message ? <div className={"alert " + (isError ? "alert-danger" : "alert-success")} >{message}</div> : <div class="alert">&nbsp;</div>
                    }
                </div>

                <div class="col-12 offset-lg-4  col-lg-4 offset-md-2   col-md-8 offset-sm-3 col-sm-6 mb-3">
                    <button type="button" onClick={logoutSite} class="btn btn-secondary btn-fill w-100">Logout</button>

                </div><div class="col-12 offset-lg-4  col-lg-4 offset-md-2  col-md-8 offset-sm-3 col-sm-6 mb-3">
                    <button type="button" onClick={logoutAllDevices} class="btn btn-secondary btn-fill w-100">Logout All Devices</button>
                </div>
             
                <div class="mt-5 col-12 offset-lg-4  col-lg-4  offset-md-2  col-md-8 offset-sm-3 col-sm-6 mb-3 text-center">

                    <button type="button" class="btn badge btn-secondary" data-bs-toggle="modal" data-bs-target="#deactivateConfirmModal">
                        Deactivate Account
                    </button>

                </div>


            </div>

            <Loader loading={loading} />


        </>
    );

}
